import React from 'react';
import { Fade } from 'react-reveal';
import { Card, CardBody, CardHeader, CardSubtitle, CardText, CardTitle, Col } from 'reactstrap';

function ExperienceCard({ data, headerColor }) {
  return (
    <Col lg="12">
      <Fade left duration={1000} distance="40px">
        <Card
          style={{ flex: 1, height: '400px' }}
          className="shadow-lg--hover shadow border-0 text-center rounded"
        >
          <CardHeader style={{ backgroundColor: headerColor }}>
            <h5 className="text-white">{data.name}</h5>
          </CardHeader>
          <CardBody className="py-5">
            <img
              className=" bg-white rounded-circle mb-3 img-center img-fluid shadow-lg p-1"
              top
              src={data.logo}
              style={{ width: '100px' }}
              alt=""
            />
            <CardTitle tag="h5">{data.role}</CardTitle>
            <CardSubtitle>{data.date}</CardSubtitle>
            <CardText className="description my-3 text-left">{data.desc}</CardText>
            <div />
          </CardBody>
        </Card>
      </Fade>
    </Col>
  );
}

export default ExperienceCard;
